const LS_KEY = 'pt_content_overrides_v1'

let overrides: Record<string, string> = {}
try {
  const raw = typeof window !== 'undefined' ? window.localStorage.getItem(LS_KEY) : null
  overrides = raw ? JSON.parse(raw) : {}
} catch {}

function save() {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(LS_KEY, JSON.stringify(overrides))
}

export function getText(key: string, fallback: string) {
  return overrides[key] ?? fallback
}

export function setText(key: string, value: string) {
  overrides[key] = value
  save()
}

export function exportOverrides(): string {
  return JSON.stringify(overrides, null, 2)
}

export function importOverrides(json: string) {
  const obj = JSON.parse(json)
  if (obj && typeof obj === 'object') {
    overrides = obj
    save()
  }
}

export function clearOverrides() {
  overrides = {}
  save()
}
